import {
  HTTP,
} from './DrupalSettings/api';

import DrupalSettings from './DrupalSettings/searchInfos';

export default class Search {
  static fetchUrl = `${DrupalSettings.apiBasePath}solr/request/ajax/`;

  static getSearchInfo(what, where, filtres, sort, qty, page, forYou, userLat, userLon) {
    const randId = DrupalSettings.rand_id ? DrupalSettings.rand_id : 0;
    return HTTP({
      url: this.fetchUrl,
      method: 'POST',
      params: {
        index: 'information',
        facet: 1,
        facet_treat: 1, // horizontal filter
        info: 'treat', // display highlight
        what,
        where,
        filtres: filtres ? JSON.stringify(filtres) : filtres,
        qty,
        page,
        rand_id: randId,
        sort,
        for_you: forYou,
        userLat,
        userLon,
      },
    });
  }

  static getSearchResultsInformations() {
    if (window?.drupalSettings?.sante_resultats_edito) {
      return window?.drupalSettings?.sante_resultats_edito;
    }
    return {};
  }
}
